<h3>สมัครใช้บริการ</h3>
<div class="uk-flex uk-flex-middle uk-flex-column ">
  <div class="uk-margin-bottom">
    <div>ลูกค้าสามารถสมัครใช้บริการกับ LINE ID</div>
    <div>เดียวเท่านั้น หากคุณดำเนินการต่อ ข้อมูล</div>
    <div>ที่สมัครกับ LINE ID เดิมจะหายไป</div>
  </div>

  <div class="uk-margin-top">
    <button type="submit"
      class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
      (click)="onClickConfirme()">ยืนยัน
    </button>
    <div class="uk-margin-top">
      <a class="uk-text-meta uk-margin-small-right" (click)="redirectToChateRoom()"><u>กลับไปยังห้องสนทนา</u></a>
    </div>
  </div>
</div>